export const EMAIL_GET_TEMPLATE = "EMAIL_GET_TEMPLATE";
export const EMAIL_GET_TEMPLATE_SUCCESS = "EMAIL_GET_TEMPLATE_SUCCESS";
export const EMAIL_GET_TEMPLATE_ERROR = "EMAIL_GET_TEMPLATE_ERROR";
export const EMAIL_SEND = "EMAIL_SEND";
export const EMAIL_SEND_SUCCESS = "EMAIL_SEND_SUCCESS";
export const EMAIL_SEND_ERROR = "EMAIL_SEND_ERROR";